import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { supabase } from '../lib/supabase';
import LanguageToggle from './LanguageToggle';

interface Props {
  onAuthenticated: () => void;
}

const LoginScreen: React.FC<Props> = ({ onAuthenticated }) => {
  const { t } = useTranslation();
  const [loading, setLoading] = useState<'google' | 'github' | 'anon' | null>(null);
  const [error, setError] = useState<string | null>(null);

  const handleOAuth = async (provider: 'google' | 'github') => {
    setLoading(provider);
    setError(null);
    const { error } = await supabase.auth.signInWithOAuth({
      provider,
      options: { redirectTo: window.location.origin + '/auth/callback' },
    });
    if (error) {
      setError(error.message);
      setLoading(null);
    }
    // 成功后页面会跳转，无需额外处理
  };

  const handleAnonymous = async () => {
    setLoading('anon');
    setError(null);
    const { error } = await supabase.auth.signInAnonymously();
    if (error) {
      setError(error.message);
      setLoading(null);
    } else {
      onAuthenticated();
    }
  };

  return (
    <div className="login-screen">
      <div className="login-lang-toggle"><LanguageToggle /></div>
      <div className="login-header">
        <div className="perspective-logo">⚖️</div>
        <h1 className="perspective-title">BorderJudge</h1>
        <p className="perspective-subtitle">{t('login.subtitle')}</p>
      </div>

      <div className="login-card">
        <button
          className="login-oauth-btn google"
          onClick={() => handleOAuth('google')}
          disabled={loading !== null}
        >
          <span className="login-oauth-icon">G</span>
          {loading === 'google' ? t('login.connecting') : t('login.google')}
        </button>

        <button
          className="login-oauth-btn github"
          onClick={() => handleOAuth('github')}
          disabled={loading !== null}
        >
          <span className="login-oauth-icon">⌥</span>
          {loading === 'github' ? t('login.connecting') : t('login.github')}
        </button>

        <div className="login-divider">
          <span>{t('login.or')}</span>
        </div>

        <button
          className="login-anon-btn"
          onClick={handleAnonymous}
          disabled={loading !== null}
        >
          {loading === 'anon' ? t('login.connecting') : t('login.anonymous')}
        </button>

        <p className="login-anon-hint">{t('login.anonymousHint')}</p>

        {error && <p className="login-error">{error}</p>}
      </div>
    </div>
  );
};

export default LoginScreen;
